<script>

    import ModalEdit from '../../../layouts/ModalEdit.vue';
    import attributeSelector from '../../config/attribute/Select.vue';

    export default {
        name: 'modal',
        props: ['value','attributes'],
        extends: ModalEdit,
        components:{
            attributeSelector
        },
        data: function () {
            return {
                internalValue: '',
                locales: null,
                locale: 'all',
                localesLoaded: true,
                selection: {},
                children: {}
            }
        },
        mounted: function(){
            this.locales = this.$store.state.scope.locales
            this.locale = this.$store.state.scope.locales[0].id
        },
        created: function() {
            this.internalValue = this.value;

            if( this.internalValue.attribute.children.length ){
                this.children = {}
            }
            for(let item of this.internalValue.attribute.children){
                this.children[item.slug] = {}
            }

            this.initialize();
        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(){
                //this.internalValue.attribute.as == this.is_variation ? 'variation' : 'attribute';
                /*
                let combination = []
                for(let item of this.internalValue.attribute){
                    if( item.selection.length > 0 ){
                        combination.push(item)
                    }
                }
                this.internalValue.data = {
                    attributes: combination
                }*/
                this.$emit('validate')
            },
            addSelection: function(){

                if( this.selection.slug ){
                    // ok
                }else{
                    alert("Empty fields...")
                    return true;
                }

                if( this.internalValue.attribute.children.length ){

                    let selection = []
                    selection.push(this.selection)
                    for(let item of this.internalValue.attribute.children){
                        selection.push(this.children[item.slug])
                    }

                    this.internalValue.combination.push(selection)

                }else{

                    this.internalValue.combination.push(this.selection)

                }


                this.$forceUpdate()
            },
            removeSelection: function(index){
                this.internalValue.combination.splice(index,1)
                this.$forceUpdate()
            },
            setAs: function(val){
                this.internalValue.attribute.as = val ? 'variation' : 'attribute'
                this.$forceUpdate()
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                //this.is_variation = this.internalValue.attribute.as ? 'variation' : 'attribute'
            }
        }
    };
</script>
<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="close()"></div>
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article v-if="internalValue.data" >
                    <header
                            class="modal-header"
                            id="modalTitle">
                        <figure><i class="icon icon-icon_list"></i></figure>
                        <div>
                            <h1>Attribute</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>
                    <div>


                            <form-toggle label="As variation" v-model="internalValue.is_variation" :callback="setAs"></form-toggle>


                            <div>
                                <attribute-selector :label="internalValue.attribute.name"
                                             multiple="false"
                                             v-model="selection" :id="internalValue.attribute.id"
                                             :options="internalValue.attribute.values"></attribute-selector>

                            </div>

                            <div v-for="attribute in internalValue.attribute.children">

                                <attribute-selector :label="attribute.name"
                                             multiple="false"
                                             v-model="children[attribute.slug]" :id="attribute.id"
                                             :options="attribute.values"></attribute-selector>


                            </div>

                        <button @click="addSelection()"><span>Ajouter</span></button>

                        <div v-for="item, index in internalValue.combination">

                            <div v-if="item.slug">
                                <span>{{ item.name ? item.name : item.slug }} <button @click="removeSelection(index)">x</button></span>
                            </div>

                            <div v-if="item[0] && item[0].slug">
                                <span v-for="attr in item">{{ attr.name ? attr.name : attr.slug }} </span>
                                <button @click="removeSelection(index)">x</button>
                            </div>

                        </div>

                    </div>
                </article>
            </div>
        </div>
    </transition>
</template>


// WEBPACK FOOTER //
// src/modules/shop/product/ModalCombination.vue